import { motion } from "framer-motion";
import {
  Gift,
  Coffee,
  Heart,
  UtensilsCrossed,
  Camera,
  DoorOpen,
} from "lucide-react";

const timelineEvents = [
  {
    id: 1,
    time: "10:00",
    title: "Arrival & Reception",
    description: "Guests arrive and are invited to sit in the places provided.",
    icon: Heart,
  },
  {
    id: 2,
    time: "10:30",
    title: "Sangjit Procession",
    description:
      "Starting from the exchange traditional engagement gifts between families (Hantaran)",
    icon: Gift,
  },
  {
    id: 3,
    time: "11:30",
    title: "Lunch",
    description: "Intimate family gathering with traditional cuisine",
    icon: UtensilsCrossed,
  },
  {
    id: 4,
    time: "12:30",
    title: "Mingle",
    description:
      "Couple come to greeting the familesThe couple came to say hello and take photos with the family.",
    icon: Camera,
  },
  {
    id: 5,
    time: "13:00",
    title: "Closing",
    description: "The sangjit procession ends with the return of gifts",
    icon: DoorOpen,
  },
];

const TimelineItem = ({ event, index, isLast }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      className="relative flex items-start gap-4 sm:gap-6 md:gap-8"
      data-testid={`timeline-item-${event.id}`}
    >
      {/* Time - Hidden on mobile, shown on desktop left */}
      <div className="hidden md:block w-20 lg:w-24 text-right flex-shrink-0">
        <span className="font-serif-heading text-xl lg:text-2xl text-[#8B0000]">
          {event.time}
        </span>
      </div>

      {/* Center Line & Node */}
      <div className="relative flex flex-col items-center flex-shrink-0">
        {/* Node */}
        <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border-2 border-[#D4AF37] bg-[#FCFAF2] flex items-center justify-center z-10">
          <event.icon className="w-4 h-4 sm:w-5 sm:h-5 text-[#8B0000]" />
        </div>

        {/* Line */}
        {!isLast && (
          <div className="w-px h-full min-h-[80px] sm:min-h-[100px] bg-gradient-to-b from-[#D4AF37] to-transparent absolute top-10 sm:top-12" />
        )}
      </div>

      {/* Content */}
      <div className="flex-1 pb-8 sm:pb-12 md:pb-16">
        {/* Time - Mobile only */}
        <span className="md:hidden font-serif-heading text-base sm:text-lg text-[#D4AF37] mb-0.5 sm:mb-1 block">
          {event.time}
        </span>

        <h4 className="font-serif-heading text-lg sm:text-xl md:text-2xl text-[#8B0000] mb-1 sm:mb-2">
          {event.title}
        </h4>
        <p className="font-sans text-xs sm:text-sm md:text-base text-[#5A5A5A] leading-relaxed max-w-md">
          {event.description}
        </p>
      </div>
    </motion.div>
  );
};

const Timeline = () => {
  return (
    <section
      className="section-wrapper py-16 sm:py-20 md:py-32 px-4 sm:px-6 bg-white/50"
      data-testid="timeline-section"
    >
      <div className="max-w-3xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 sm:mb-16"
        >
          <p className="font-serif-accent text-[10px] sm:text-xs tracking-[0.2em] sm:tracking-[0.3em] text-[#D4AF37] uppercase mb-3 sm:mb-4">
            Ceremony
          </p>
          <h2 className="font-serif-heading text-2xl sm:text-3xl md:text-5xl text-[#8B0000] mb-3 sm:mb-4">
            Sangjit Timeline
          </h2>
          <p className="font-sans text-xs sm:text-sm text-[#5A5A5A] max-w-md mx-auto px-4">
            The traditional Chinese-Indonesian engagement ceremony, a beautiful
            union of two families
          </p>
        </motion.div>

        {/* Timeline */}
        <div className="relative pl-2 sm:pl-0">
          {timelineEvents.map((event, index) => (
            <TimelineItem
              key={event.id}
              event={event}
              index={index}
              isLast={index === timelineEvents.length - 1}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Timeline;
